var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M0.999997 8.73205C-0.333336 7.96225 -0.333333 6.03775 1 5.26795L8.5 0.937821C9.83334 0.168021 11.5 1.13027 11.5 2.66987L11.5 11.3301C11.5 12.8697 9.83333 13.832 8.5 13.0622L0.999997 8.73205Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateback);
export default __webpack_public_path__ + "static/media/navigateback.d4c33e5bb2feacb1dc38191eef5b5637.svg";
export { ForwardRef as ReactComponent };